import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { AuthService } from "@/services/auth.service";

const auth = {
  namespaced: true,
  state: {
    user: {},
    token: null,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUser(state, userObj) {
      state.user = userObj;
    },
  },
  actions: {
    async fetchUser({ commit }) {
      try {
        commit("startLoading", null, { root: true });

        const user = await AuthService.me().then((response) =>
          denormalize(response.data)
        );

        commit("setUser", user);
        commit("endLoading", null, { root: true });
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    hasPermission: (state) => (permission) => {
      const permissions = state.user.permissions || [];
      return permissions.findIndex((p) => p.name === permission) > -1;
    },
    isContractor: (state) => {
      // At the moment only non-contractors have a firm_id assigned.
      // [2021-11-23] - Added null value as "yet to be determined"
      if ( ! state.user.id) return null;
      return state.user.firm_id ? false : true;
    },
  },
};

export default auth;
